import { availableLanguages } from "./data/languageData";
import moment from "moment";
import { saveAs } from "file-saver";


export function formatString(input) {
    let words = input?.replace(/_/g, ' ')?.split(' ');
    let formattedWords = words?.map(word => word?.charAt(0)?.toUpperCase() + word?.slice(1));
    return formattedWords?.join(' ');
}

export function truncateString(str, count = 25) {
    if (str.length > 25) {
        return str.slice(0, count) + "...";
    }
    return str;
}

export const getLangName = (value) => {
    const match = availableLanguages.find(item => item.value === value);
    return match?.label || null;
};

export const formatDateTime = (dateTime) => {
    if (!dateTime) return "";

    return moment.utc(dateTime).format("MMM DD, YYYY hh:mm A");
};

export const fileDownload = async (url, fileName) => {
    try {
        const response = await fetch(url);
        const blob = await response.blob();
        saveAs(blob, fileName); // Triggers the download
    } catch (error) {
        console.error('Download failed:', error);
    }
}


export const filterUpdatedTextblocks = (updatedContents) => {
    const processedParts = updatedContents.map(part => {
        if (part.updatedSentence) return part;

        // Split into sentences with numbered-list detection
        const splitText = (text) => {
            if (!text) return [];

            // If the text looks like a numbered list item, don't split
            // Matches: "1. text", "12. something", "99. another"
            if (/^\d+\.\s*/.test(text.trim())) {
                return [text.trim()];
            }

            // Otherwise, do normal sentence splitting
            return text
                .split(/(?<=[.!?])\s+/)
                .map(s => s.trim())
                .filter(Boolean);
        };

        const sourceSentences = splitText(part.source);
        const translatedSentences = splitText(part.translated);
        const updatedSentences = splitText(part.updated);

        console.log('sourceSentences :>> ', sourceSentences);
        console.log('updatedSentences :>> ', updatedSentences);

        const changedSentences = [];
        for (let i = 0; i < translatedSentences.length; i++) {
            if (translatedSentences[i] !== updatedSentences[i]) {
                changedSentences.push({
                    source: sourceSentences[i] || "Source text not available",
                    translated: translatedSentences[i],
                    updated: updatedSentences[i],
                });
            }
        }

        return changedSentences.length > 0
            ? changedSentences[0]
            : {
                sourceSentence: part.source,
                translatedSentence: part.translated,
                updatedSentence: part.updated,
                position: 1
            };
    });

    console.log('Processed updatedParts:', processedParts);
    return processedParts;
};

